import Vue from "vue";
import Vuex from "vuex";
import vuetify from "./plugins/vuetify";

import auth from "./auth.js";

import store from "./store";

import "./plugins";
import "./filters";

import "./utils/injectedMethods.js";

import App from "./App.vue";
import router from "./router";

import { throwBackendError, throwClientError } from "@/errors/handler.js";

Vue.config.productionTip = false;

window.addEventListener("unhandledrejection", (err) => {
  throwBackendError(err);
});

Vue.config.errorHandler = (error) => {
  throwClientError(error);
};

import DataList from "./components/DataList.vue";
import CustomTextField from "./components/CustomTextField.vue";
import InfoMenu from "./components/InfoMenu.vue";
import CreatePaymentBtn from "./views/integration/privat24/CreatePaymentBtn.vue";
import TransactionTypeLabel from "./views/integration/privat24/TransactionTypeLabel.vue";
import ReportNumber from "./components/ReportNumber.vue";
import ReferenceTitle from "./components/ReferenceTitle";
import PasswordField from "@/components/PasswordField.vue";
import LazyAutocomplete from "@/components/story/LazyAutocomplete.vue";
import Label from "@/components/Label.vue";

Vue.component("DataList", DataList);
Vue.component("CustomTextField", CustomTextField);
Vue.component("InfoMenu", InfoMenu);
Vue.component("CreatePaymentBtn", CreatePaymentBtn);
Vue.component("TransactionTypeLabel", TransactionTypeLabel);
Vue.component("ReportNumber", ReportNumber);
Vue.component("ReferenceTitle", ReferenceTitle);
Vue.component("PasswordField", PasswordField);
Vue.component("LazyAutocomplete", LazyAutocomplete);
Vue.component("Label", Label);

import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
Vue.use(Vuex);

import moment from "moment";
moment.locale("uk");
Vue.mixin({
  data() {
    return {
      get moment() {
        return moment;
      },
    };
  },
});

router.beforeEach((to, from, next) => {
  const role = auth.getRole();
  if (!to.meta.permissions?.includes(role)) {
    return;
  }
  if (to.name !== "login" && !auth.loggedIn()) {
    Vue.prototype.$toLink = to.path;
    auth.logout();
    next({ name: "login" });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  const documentTitle = to.meta.title ? `${to.meta.title} | ` : "";
  document.title = `${documentTitle}Tqm Cab`;
  next();
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
